export default __webpack_public_path__ + "static/youvegotmail-92af4579f8386abb9aa4bb78f41a68a3.svg";